import chroma from 'chroma-js';

export const getRandomColors = () => {
  let color = chroma.random();
  let [, s, l] = color.hsl();

  while (s < 0.5 || s > 0.8 || l < 0.4 || l > 0.7) {
    color = chroma.random();
    [, s, l] = color.hsl();
  }

  return color.hex();
};

export const getRandomColorForEachElement = (elements: unknown[]) => {
  return elements.map(() => {
    return getRandomColors();
  });
};
